// src/pages/AuthRedirect.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import "../assets/css/auth-redirect.css";

const clientUrl =
  process.env.REACT_APP_CLIENT_URL || "http://localhost:3000";

const AuthRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      // 👉 HASH: #<base64>&to=/admin
      const hash = window.location.hash.replace("#", "");
      if (!hash) throw new Error("Missing auth hash");

      const [payloadPart, toPart] = hash.split("&to=");
      const redirectTo = toPart ? decodeURIComponent(toPart) : "/dashboard";

      const decoded = JSON.parse(
        atob(decodeURIComponent(payloadPart))
      );

      const { token, user } = decoded;

      if (!token || !user) throw new Error("Invalid payload");

      // ✅ Lưu auth
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      // ⏱ UX delay nhẹ
      setTimeout(() => {
        navigate(redirectTo, { replace: true });
      }, 800);
    } catch (err) {
      console.error("AuthRedirect error:", err);
      window.location.href = `${clientUrl}/auth?tab=login`;
    }
  }, [navigate]);

  return (
    <div className="auth-redirect-container">
      <FaSpinner className="auth-spinner" />
      <p>Đang chuyển hướng đến trang quản trị...</p>
    </div>
  );
};

export default AuthRedirect;
